import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  TerminalsTypes,
  TerminalInterface,
  TerminalConfigInterface,
} from './types';

// List Terminals
export const listTerminalsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(TerminalsTypes.LIST_TERMINALS_REQUEST, payload);

export const listTerminalsSuccess = (payload: {
  terminalList: TerminalInterface[];
  totalCount: number;
}) => action(TerminalsTypes.LIST_TERMINALS_SUCCESS, payload);

export const listTerminalsFailure = () =>
  action(TerminalsTypes.LIST_TERMINALS_FAILURE);

// Get Terminal
export const getTerminalRequest = (payload: object) =>
  action(TerminalsTypes.GET_TERMINAL_REQUEST, payload);

export const getTerminalSuccess = (payload: {
  terminalData: TerminalInterface;
}) => action(TerminalsTypes.GET_TERMINAL_SUCCESS, payload);

export const getTerminalFailure = () =>
  action(TerminalsTypes.GET_TERMINAL_FAILURE);

// Filter Terminals
export const filterTerminalsRequest = (payload: object) =>
  asyncAction(TerminalsTypes.FILTER_TERMINALS_REQUEST, payload);

export const filterTerminalsSuccess = (payload: {
  terminalList: TerminalInterface[];
  totalCount: number;
}) => action(TerminalsTypes.FILTER_TERMINALS_SUCCESS, payload);

export const filterTerminalsFailure = () =>
  action(TerminalsTypes.FILTER_TERMINALS_FAILURE);

// Create Terminal
export const createTerminalRequest = (payload: object) =>
  action(TerminalsTypes.CREATE_TERMINAL_REQUEST, payload);

export const createTerminalSuccess = (payload: {
  terminalData: TerminalInterface;
}) => action(TerminalsTypes.CREATE_TERMINAL_SUCCESS, payload);

export const createTerminalFailure = () =>
  action(TerminalsTypes.CREATE_TERMINAL_FAILURE);

// Update Terminal
export const updateTerminalRequest = (payload: any) =>
  action(TerminalsTypes.UPDATE_TERMINAL_REQUEST, payload);

export const updateTerminalSuccess = () =>
  action(TerminalsTypes.UPDATE_TERMINAL_SUCCESS);

export const updateTerminalFailure = () =>
  action(TerminalsTypes.UPDATE_TERMINAL_FAILURE);

// Delete Terminal
export const deleteTerminalRequest = (payload: object) =>
  action(TerminalsTypes.DELETE_TERMINAL_REQUEST, payload);

export const deleteTerminalSuccess = () =>
  action(TerminalsTypes.DELETE_TERMINAL_SUCCESS);

export const deleteTerminalFailure = () =>
  action(TerminalsTypes.DELETE_TERMINAL_FAILURE);

// Update Gate
export const gateUpdateRequest = (payload: any) =>
  asyncAction(TerminalsTypes.GATE_UPDATE_REQUEST, payload);

// List Terminal Config
export const listTerminalConfigRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(TerminalsTypes.LIST_TERMINAL_CONFIG_REQUEST, payload);

export const listTerminalConfigSuccess = (payload: {
  terminalConfigList: TerminalConfigInterface[];
  totalCount: number;
}) => action(TerminalsTypes.LIST_TERMINAL_CONFIG_SUCCESS, payload);

export const listTerminalConfigFailure = () =>
  action(TerminalsTypes.LIST_TERMINAL_CONFIG_FAILURE);

// Update School Settings
export const updateTerminalConfigRequest = (payload: object) =>
  action(TerminalsTypes.UPDATE_TERMINAL_CONFIG_REQUEST, payload);
export const updateTerminalConfigSuccess = (payload: {
  terminalConfigData: TerminalConfigInterface;
}) => action(TerminalsTypes.UPDATE_TERMINAL_CONFIG_SUCCESS, payload);
export const updateTerminalConfigFailure = () =>
  action(TerminalsTypes.UPDATE_TERMINAL_CONFIG_FAILURE);
